import { render, staticRenderFns } from "./thank-you-popup.vue?vue&type=template&id=433aadfe"
import script from "./thank-you-popup.vue?vue&type=script&lang=js"
export * from "./thank-you-popup.vue?vue&type=script&lang=js"
import style0 from "./thank-you-popup.vue?vue&type=style&index=0&id=433aadfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports